;; ##canonical##
(ns kc.core
  (:refer-clojure :exclude [assert])
  #?(:cljs (:require-macros
            [kc.core :refer [SRC THROW mk-error -mk-env TEST
                             def-ui $ use-effect
                             assert assert-type assert=]]))
  (:require

   ;; https://developers.google.com/closure/compiler/docs/overview?hl=en
   ;; https://google.github.io/closure-library/api/goog.html
   ;; #?(:cljs [goog.date :as goog-date])

   [clojure.string :as str]
   [clojure.pprint :refer [pprint]]
   [clojure.edn :as edn]
   [kc.interface :as interface]
   [kc.impl.base62 :as base62]
   #?(:clj [kc.impl.macro-helpers :as macro-helpers])))

#?(:cljs
   (do
     (-> js/globalThis .-kc-log-message (set! js/console.log))
     (-> js/globalThis .-kc-log-error (set! js/console.error))))

(defn tsm []
  #?(:cljs (.getTime (js/Date.))
     :clj (System/currentTimeMillis)))

(defn inst []
  #?(:cljs (js/Date.)
     :clj (java.util.Date.)))


;;; strings

(defn str-split-by-whitespace [s]
  (when s
    (str/split s #"\s+")))

(defn str-non-blank [s]
  (when (string? s)
    (when-not (str/blank? s)
      s)))

(defn str-trimmed-non-blank [s]
  (when s
    (-> s str str/trim str-non-blank)))

(defn str-pad-left[s min-len padding]
  (when s
    (let [s       (if (string? s) s (str s))
          padding (if (string? padding) padding (str padding))]
      (if (-> padding count (= 0))
        s
        (if (-> s count (>= min-len))
          s
          (recur (str padding s) min-len padding))))))

(defn str-includes-all? [s substrs]
  (->> substrs
       (remove #(str/includes? s %))
       empty?))

;;; UUID


(defn uuid->base62 [uuid]
  (base62/uuid->base62 uuid))

(defn random-uuid-base62 []
  (uuid->base62 (random-uuid)))

;;; EDN

(defn ->edn [data]
  (cond

    (or (keyword? data) (number? data) (boolean? data))
    (str data)

    :else
    (with-out-str (pprint data)))
  )

(defn read-edn [s]
  (when s
    (edn/read-string s)))


;;; promises

#?(:cljs
   (defn all> [promises]
     (-> (js/Promise.allSettled promises)
         (.then (fn [results]
                  (->> results
                       (mapv (fn [^js result]
                               (when-let [error (-> result .-reason)]
                                 (throw error))
                               (-> result .-value)))))))))


;;; logging
      
(defmacro log [& messages]
  (let [prod? true
        in-browser? false
        cljs? (boolean &env)
        error? false
        important? false
        message nil
        special-value nil]
    (if cljs?
      (macro-helpers/log-output--js
       &env *ns* prod? in-browser?
       error? important? message special-value
       messages)
      (macro-helpers/log-output--print
       &env error? important? messages))))

(defmacro log-error [& messages]
  (let [prod? true
        in-browser? false
        cljs? (boolean &env)
        error? true
        important? true
        message nil
        special-value nil]
    (if cljs?
      (macro-helpers/log-output--js
       &env *ns* prod? in-browser?
       error? important? message special-value
       messages)
      (macro-helpers/log-output--print
       &env error? important? messages))))
 
(defmacro log! [& messages]
  (let [prod? true
        in-browser? false
        cljs? (boolean &env)
        error? false
        important? true
        message nil
        special-value nil]
    (if cljs?
      (macro-helpers/log-output--js
       &env *ns* prod? in-browser?
       error? important? message special-value
       messages)
      (macro-helpers/log-output--print
       &env error? important? messages))))

;;; context

(defmacro -mk-env []
  (let [tsm (System/currentTimeMillis)
        env {;; :keys (keys &env)
             ;; :DEBUG (->> &env :fn-scope (take 10))

             :build/mode (-> &env :shadow.build/mode)
             ;; :fn-scope (-> &env :fn-scope)
             ;; :shadow.build/root-form (-> &env :shadow.build/root-form)

             :build/tsm tsm
             :build/inst (inst)}]

    `'~env))

(def -env (-mk-env))

(def rt-live? #?(:cljs (boolean (not goog.DEBUG))
                      :clj false))
;;; introspection

(defmacro SRC
  "Macro: current source code location.

  `{:src/ns some/namespace
    :src/file \"some/namespace.cljc\"
    :src/line 42}`"
  []
  (let [src (macro-helpers/src-from-env &form &env *ns*)]
    `'~src))

(comment
  (macroexpand '(SRC))
  )

;;; errors

(defmacro mk-error
  [message & [data cause]]
  (when (nil? (:file (meta &form)))
    (println " [WARN] kc.core/mk-error: Missing macro metadata. Nested macro? " &form))
  (let [[message data] (macro-helpers/parse-error-form message data)]
    `(ex-info ~message
              ;; TODO optimize by removing merge
              (merge ~data
                     {:err/source '~(macro-helpers/src-from-env &form &env *ns*)})
              ~cause)))

(defmacro THROW
  [message & [data cause]]
  #_(when (nil? (:file (meta &form)))
      (println " [WARN] kc.core/THROW: Missing macro metadata. Nested macro?"))
  (let [[message data] (macro-helpers/parse-error-form message data)
        source (macro-helpers/src-from-env &form &env *ns*)
        source (cond
                 (:src/file source) source
                 (:src/file (:err/source data)) (:err/source data)
                 :else (or source (:err/source data)))]

    `(do
       (print "\n-- THROWING ERROR --\n"
              "\n-- message: --------\n"
              ~message
              "\n-- data: -----------\n"
              ~data
              "\n-- source: ---------\n"
              ~source)
       (when ~cause
         (print "\n-- cause: ---------\n"
                ~cause
                "\n-- cause-data: ----\n"
                (as-error-data ~cause)
                "\n--------------------\n"))
       (throw
        (ex-info ~message
                 (assoc ~data :err/source' ~source)
                 ~cause)))))

(defn error-data? [thing]
  (boolean (:err/message thing)))

(defn- -conform-error-stack-line [line]
  (when line
    (when-not (or (str/includes? line "runtime/shadow.cljs")
                  (str/includes? line "runtime/shadow.cljs")
                  (str/includes? line "react_dom_client_development.js")
                  (str/includes? line "runtime/cljs.core.js"))
      (let [line (str/trim line)
            line (if (str/starts-with? line "at ")
                   (subs line 3)
                   line)
            line (str/trim line)]
        line))))

(defn- -conform-error-stack [stack]
  (when stack
    (let [lines (str/split-lines stack)]
      (->> lines
           (mapv -conform-error-stack-line)
           (remove nil?)
           (into [])))))

(defn -error-message-cleaned-up-for-user [s]
  (when s
    (->> s
         str/split-lines
         (remove #(str/starts-with? % "    at "))
         (str/join "\n"))))

(defn error-user-message [error]
  ;; (assert-type error-data? error)
  (if-let [cause (or (-> error :err/cause)
                     (-> error :cause))]
    (str (error-user-message cause)
         " ➤ "
         (or
          (-> error :err/message -error-message-cleaned-up-for-user)
          (-> error :message -error-message-cleaned-up-for-user))
         )
    (or (-> error :err/message -error-message-cleaned-up-for-user)
        (-> error :message -error-message-cleaned-up-for-user))))


(defn as-error-data
  "Converts `thing` to error map."
  [thing]
  (try
    (cond
      (nil? thing)
      {:err/id ::error-as-nil
       :err/message "Unexpected nil"}

      (error-data? thing) thing

      (string? thing)
      {:err/message thing}

      ;; TODO Java Throwable

      #?(:cljs
         (instance? js/Error thing))
      #?(:cljs
         (let [filename (-> thing .-fileName)
               source (or
                       (when filename
                         {:src/file filename
                          :src/line (-> thing .-lineNumber)})
                       (when-let [data (-> thing .-data)]
                         (when (map? data)
                           (get data :err/source))))]
           {:err/id ::javascript-error
            :err/message (-> thing .-message)
            :err/cause (when-let [cause (-> thing .-cause)]
                         (as-error-data cause))
            :err/stack (-conform-error-stack (-> thing .-stack))
            :err/source source
            :err/data (when-let [data (-> thing .-data)]
                        (cond
                          (nil? data) nil
                          (map? data) (when-not (empty? data)
                                        (-> data
                                            (dissoc :err/source)))
                          :else data))}))

      (map? thing)
      {:err/id ::error-as-map
       :err/message "Error with data"
       :err/data thing}

      #?(:cljs
         (instance? js/Object thing))
      #?(:cljs
         {:err/id ::error-as-js-object
          :err/message "Error as JavaScript object"
          :err/data {:js-object thing}})

      :else
      {:err/id ::error-as-unsupported-thing
       :err/message (str thing)
       :err/data {:thing thing}})

    (catch #?(:cljs :default :clj Exception) ex
      {:err/id ::error-conforming-error
       :err/message "kc.core/->error failed"
       :err/data {:thing-which-failed-to-interpret thing}
       :err/cause (str ex)})))


;;; assertions

#?(:clj
   (defn -macro-assert [macro-form macro-env macro-ns assertion message data]
     (when (nil? (:file (meta macro-form)))
       (println " [WARN] kc.core/assert: Missing macro metadata. Nested macro?"))
     (when message
       (clojure.core/assert (or (qualified-keyword? message)
                                (string? message))))
     (when data
       (clojure.core/assert (map? data)))
     (let [assertion-formated (with-out-str (pprint assertion))
           assertion-formated (-> assertion-formated (str/replace "\n" " "))
           data (assoc data :err/assertion assertion-formated)

           source (macro-helpers/src-from-env macro-form macro-env macro-ns)
           data (assoc data :err/source source)
           message (or message ::assert-failed)]

       `(let [value# ~assertion]
          (or value#
              (THROW ~message
                     ~data))))))

(defmacro assert [assertion & [message data]]
  (-macro-assert &form &env *ns* assertion message data))

(defn -form->code [form]
  (str/trim (with-out-str (pprint form))))

#?(:clj
   (defn -macro-assert-type [macro-form macro-env macro-ns
                             type-predicate-function test-form message data]
     (when (nil? (:file (meta macro-form)))
       (println " [WARN] kc.core/assert-type: Missing macro metadata. Nested macro?"))
     (when message
       (clojure.core/assert (or (qualified-keyword? message)
                                (string? message))))
     (when data
       (clojure.core/assert (map? data)))
     (let [assertion-formated (-form->code (list type-predicate-function test-form))
           assertion-formated (-> assertion-formated (str/replace "\n" " "))
           data (assoc data :err/assertion assertion-formated)

           source (macro-helpers/src-from-env macro-form macro-env macro-ns)
           data (assoc data :err/source source)

           message (or message ::assert-type-failed)]

       `(let [value# ~test-form]
          (when (nil? value#)
            (THROW ~message
                   ~data))
          (when-not (~type-predicate-function value#)
            (THROW ~message
                   ~data
                   #_(assoc ~data
                            :form-evaled value#)))

          value#))

     ))

(defmacro assert-type [type-predicate-function test-form & [message data]]
  (-macro-assert-type &form &env *ns* type-predicate-function test-form message data))

#_
(defmacro assert-type [type-predicate-function test-form & [message data]]
  (when (nil? (:file (meta &form)))
    (println " [WARN] kc.core/assert-type: Missing macro metadata. Nested macro?"))
  (when message
    (clojure.core/assert (or (qualified-keyword? message)
                             (string? message))))
  (when data
    (clojure.core/assert (map? data)))
  (let [assertion-formated (-form->code (list type-predicate-function test-form))
        assertion-formated (-> assertion-formated (str/replace "\n" " "))
        data (assoc data :err/assertion assertion-formated)

        source (macro-helpers/src-from-env &form &env *ns*)
        data (assoc data :err/source source)

        message (or message ::assert-type-failed)]

    `(let [value# ~test-form]
       (when (nil? value#)
         (THROW ~message
                ~data))
       (when-not (~type-predicate-function value#)
         (THROW ~message
                ~data
                #_(assoc ~data
                         :form-evaled value#)))

       value#))
  )

;; FIXME use THROW and provide :err/source
(defmacro assert= [expected-value form]
  `(let [value# ~form]
     (assert (= ~expected-value value#))
     value#))

;;; user interface (HTML)

(defn destruct-attrs-and-children [attrs-and-children]
  (when (seq attrs-and-children)
    (let [first-thing (first attrs-and-children)]
      (cond

        (vector? first-thing)
        [(let [[attrs children] (destruct-attrs-and-children
                                 first-thing)]
           (assoc attrs ::classes children))
         (rest attrs-and-children)]

        (map? first-thing)
        [first-thing (rest attrs-and-children)]

        :else
        [nil attrs-and-children]))))

(defmacro $
  [component & attrs-and-children]
  (cond

    (= :DEBUG component)
    `(interface/$ :pre ~(str attrs-and-children) nil)

    (keyword? component)
    (let [[component classes] (macro-helpers/deconstruct-tag component)

          [attrs children] (destruct-attrs-and-children
                            attrs-and-children)

          classes (into classes
                        (get attrs ::classes))
          attrs (dissoc attrs ::classes)

          class (when (seq classes)
                  (->> classes
                       (map macro-helpers/to-css-class-name)
                       (str/join " ")))
          class (if-let [provided-class (-> attrs :class)]
                  (str class " " provided-class)
                  class)
          attrs (if class
                  (assoc attrs :class class)
                  attrs)]
      `(interface/$ ~component ~attrs ~children))

    :else
    (let [[attrs children] (macro-helpers/destruct-attrs-and-children
                            attrs-and-children)]
      `(interface/$ ~component ~attrs ~children))))


(def use-state interface/use-state)

;; (defmacro use-effect [& body] `(helix-hooks/use-effect ~@body))
(defmacro use-effect [& body] `(interface/use-effect ~@body))

(defmacro use-layout-effect [& body] `(interface/use-layout-effect ~@body))

(defn- -as-transformator [transformator-or-path]
  (cond
    (vector? transformator-or-path)
    #(get-in % transformator-or-path)

    (fn? transformator-or-path)
    transformator-or-path

    (keyword? transformator-or-path)
    transformator-or-path

    :else (THROW ::unsupported-transformator
                 {:transformator transformator-or-path})))

(defn use-atom

  ([ATOM]
   (use-atom ATOM identity))

  ([ATOM transformator-or-path]
   #_(assert ATOM
             ::nil-not-allowed)
   (let [transformator (-as-transformator transformator-or-path)
         [value set-value] (use-state (when ATOM (transformator @ATOM)))
         signal (str (when (or (keyword? transformator-or-path)
                               (vector? transformator-or-path))
                       transformator-or-path))]

     #?(:cljs
        (use-effect
         [ATOM
          signal]

         (set-value (when ATOM (transformator @ATOM)))
         (when ATOM
           (let [ACTIVE (volatile! true)
                 VALUE (volatile! value)
                 watch-key (random-uuid)]
             (add-watch ATOM watch-key
                        (fn [_k _r _ov nv]
                          (when @ACTIVE
                            (let [nv (transformator nv)]
                              (when-not (= nv @VALUE)
                                (vreset! VALUE nv)
                                (set-value nv))))))
             (fn []
               (vreset! ACTIVE false)
               (remove-watch ATOM watch-key)
               (set-value nil))))))

     value)))

(defn combine-atoms
  "Takes a collection of atoms. Returns [combined-atom unwatch-fn].
   combined-atom holds a vector of the source values and stays in sync."
  [atoms]
  (let [atoms (vec atoms)
        combined (atom (mapv deref atoms))
        k        (gensym "combine-atoms-")]
    (doseq [[i ATOM] (map-indexed vector atoms)]
      (assert ATOM
              ::one-atom-is-nil
              {:at-index i
               :atoms atoms})
      (add-watch ATOM k (fn [_ _ _ new-val]
                          (swap! combined assoc i new-val))))
    [combined
     (fn unwatch []
       (doseq [a atoms] (remove-watch a k))
       nil)]))

(defn use-atoms [ATOMS]
  (let [[ATOM !ATOM] (use-state nil)
        values (use-atom ATOM)]

    #?(:cljs
       (use-effect
        [(hash ATOMS)]
        (let [[NEW_ATOM unwatch] (combine-atoms ATOMS)]
          (!ATOM NEW_ATOM)
          unwatch)))

    values))

(defn mk-atom-hook
  ([ATOM]
   (mk-atom-hook ATOM identity))
  ([ATOM transformator]
   (partial use-atom ATOM transformator)))


(defmacro def-ui
  {:clj-kondo/lint-as 'clojure.core/defn}
  [component & form-body]
  (let [
        [docstring form-body] (if (string? (first form-body))
                                [(first form-body) (rest form-body)]
                                [nil form-body])
        [fn-meta form-body] (if (map? (first form-body))
                              [(first form-body) (rest form-body)]
                              [nil form-body])
        params (first form-body)
        body (rest form-body)
        opts-map? (map? (first body))
        opts (cond-> (if opts-map?
                       (first body)
                       {})
               (:wrap fn-meta) (assoc :wrap (:wrap fn-meta)))
        ;; feature flags to enable by default
        default-opts {:helix/features {:fast-refresh true
                                       :check-invalid-hooks-usage true
                                       }}
        opts (merge default-opts opts)

        params-arg (reduce (fn [m param]
                             (if (= param '***)
                               (assoc m param :children)
                               (assoc m param (keyword (name param)))))
                           {} params)

        ]
    `(interface/def-ui
       ~component
       ~params-arg
       ~body
       ~opts
       ~fn-meta
       ~docstring
       )))

;; https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Values/color_value/oklch
(defn mk-color
  "Make oklch color."
  ([lightness]
   (mk-color lightness 0 0))
  ([lightness chroma-percent hue-deg]
   (str "oklch("
        lightness " "
        chroma-percent "% "
        hue-deg "deg)")))

;;; CONTEXT

(defn context? [thing]
  (boolean (:context/id thing)))

(defn- -mk-context []
  (let [tsm (tsm)]
    (merge
     -env
     {:context/id (str (random-uuid))
      :rt/created-tsm tsm
      :rt/created-inst (inst)
      :rt/live? rt-live?
      :rt/debug-mode? #?(:cljs (boolean goog.DEBUG)
                         :clj false)}
     #?(:cljs
        {:locale (if (exists? js/navigator)
                   js/navigator.language
                   nil ;; FIXME
                   )}))))

(defonce CONTEXT (atom (-mk-context)))

(defn from-context [path-or-transformator]
  ((-as-transformator path-or-transformator) @CONTEXT))

(defn update-context! [k v]
  ;; (LOG k v)
  (cond

    (and (keyword? k) (fn? v)) (swap! CONTEXT update k v)

    (keyword? k)
    (swap! CONTEXT assoc k v)

    (and (vector? k) (fn? v))
    (swap! CONTEXT update-in k v)

    (vector? k)
    (swap! CONTEXT assoc-in k v)

    :else (THROW ::illegal-key
                 {:key k}))

  nil)

(defn update-context!--toggle [k]
  (update-context! k not))

(defn from-context-autocreate! [path constructor]
  (assert (or (qualified-keyword? path)
              (vector path)))
  (assert (fn? constructor))
  (let [v (or (from-context path)
              (let [v (constructor)]
                (update-context! path v)
                v))]
    v))

(defn debug-mode? []
  (:rt/debug-mode? @CONTEXT))

(defn !debug-mode [v]
  (update-context! :rt/debug-mode? (boolean v)))

(defn DEBUG [value]
  #_(when (debug-mode?)
    ($ :DEBUG {:thing value})))

(defn use-from-context [transformator-or-path]
  (use-atom CONTEXT transformator-or-path))

;;; promises

(defn eval> [f]
  #?(:cljs
     (js/Promise.
      (fn [resolve reject]
        (try
          (resolve (f))
          (catch #?(:cljs :default :clj Exception) ex
            (reject
             {:err/id ::error-eval>
              :err/message "kc.core/eval> failed"
              :err/data {:faild-function f}
              :err/cause ex})))))
     :clj (throw (ex-info "Not implemented for Clojure" {}))))

;;; testing

(defn register-test [test]
  (swap! CONTEXT assoc-in [:dev/tests (-> test :id)]
         test))

(defn unregister-test [id]
  (swap! CONTEXT update :dev/tests dissoc id))


(defmacro TEST [on? sym & body]
  (assert (boolean? on?))
  (assert (symbol? sym))
  (let [id (str *ns* "/" sym)
        test-fns (->> body
                      (map (fn [f]
                             `(fn [] ~f)))
                      (into []))
        ]
    (if on?
      `(register-test {:id ~id
                       :source ~(meta &form)
                       :test-fns ~test-fns})
      `(unregister-test ~id))))

#?(:cljs
   (defn run-test> [test-id]
     (let [test (from-context [:dev/tests test-id])
           _ (assert test)
           _ (update-context! :dev/tests-results
                              #(assoc % test-id
                                      {:test test
                                       :running? true}))
           results-p (->> (:test-fns test)
                          (map (fn [test-fn]
                                 (-> (eval> test-fn)
                                     (.then (fn [result]
                                              {:ok? true
                                               :result result})
                                            (fn [error]
                                              {:test-fn-error error})))))
                          js/Promise.all)]
       (-> results-p
           (.then (fn [results]
                    (update-context! :dev/tests-results
                                     #(assoc % test-id
                                             {:test test
                                              :test-fn-results results}))))))))
#?(:cljs
   (defn run-all-tests> []
     (->> (from-context :dev/tests)
          vals
          (map #(run-test> (-> % :id)))
          js/Promise.all)))
